import { endPoints, requestType } from "../lib/variable";
import Api from "./index";
const getAllNotification = (type) => {
  return Api(endPoints.getNotification, type, requestType.POST);
};
const createNotification = (payload) => {
  return Api(endPoints.createNotification, payload, requestType.POST);
};
const updateNotification = (id, payload) => {
  return Api(`${endPoints.updateNotification}/${id}`, payload, requestType.POST);
};
const deleteNotification = (id, payload) => {
  return Api(
    `${endPoints.deleteNotification}/${id}`,
    payload,
    requestType.DELETE
  );
};
export {
  getAllNotification,
  createNotification,
  updateNotification,
  deleteNotification,
};
